<template>
  <div>
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-4 box-flex ">
        <div class="card">
          <div class="row ">
            <div
              class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10  align-self-center"
            >
              <h2 class="subtitle mb-0">Gallery</h2>
              <span
                class="text-capitalize d-block f-12"
                v-if="filteredImages.length > 0"
              >
                {{ searchCriteria.vehicle.make }}
                {{ searchCriteria.vehicle.model }} |
                {{ searchCriteria.destination.name }}
              </span>
            </div>
            <div
              class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 align-self-center"
            >
              <div class="alinmov2" v-if="filteredImages.length > 0">
                <el-tooltip
                  content="Select All"
                  placement="bottom"
                  v-if="imagesSelected.length === 0"
                >
                  <span class="checkmarkall" @click="markAllGallery()"
                    ><i class="flaticon-bold-check-3"></i> </span
                ></el-tooltip>
                <el-tooltip content="Unmark" placement="bottom" v-else>
                  <span
                    class="checkmarkall noborder"
                    @click="unCkeckAllGallery()"
                    ><i class="flaticon-disable"></i> </span
                ></el-tooltip>
              </div>
            </div>
          </div>

          <div v-if="loadpreload">
            <div class="text-center p-5">
              <h4><strong>Finding Pictures...</strong></h4>
              <div id="loaderInner">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>

          <div v-else>
            <div v-if="filteredImages.length > 0">
              <div class="row ">
                <div class="col-xl-12 mt-2">
                  <base-alert
                    type="danger"
                    class="mb-1 info-min"
                    v-if="loadedVehicles === 1"
                  >
                    <i class="flaticon-warning mr-1"></i> No vehicle pictures
                    found for the selected vehicle. Click
                    <a href="/tools/vehicles-gallery" target="_blank">here</a>
                    to upload photos to the gallery.
                  </base-alert>
                  <base-alert
                    type="danger"
                    class="mb-1 info-min"
                    v-if="loadedVehicles === 2"
                  >
                    <i class="flaticon-warning mr-1"></i> Select a vehicle to
                    see the pictures.
                  </base-alert>
                </div>
              </div>
              <div
                class="col-xl-12 box-drop p-0 "
                v-if="filteredImages.length > 0"
              >
                <div
                  class="box-gallery"
                  :class="{ 'mb-4': imagesSelected.length === 0 }"
                >
                  <div class="images-box row  mt-2">
                    <div
                      v-for="(file, index) in filteredImages"
                      :key="index"
                      class="image-container"
                    >
                      <div class="image-wrapper-1">
                        <img
                          v-lazy="file"
                          alt="Preview"
                          class="preview-image-2"
                        />
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            :id="file"
                            name="imagesCheck"
                            :value="file"
                            v-model="imagesSelected"
                          />
                          <span class="check"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="text-center pt-2 pb-3 border-top"
                v-if="imagesSelected.length > 0"
              >
                <base-button
                  type="primary"
                  class="min-button mb-0"
                  @click="selectGallery()"
                >
                  <i class="flaticon-bold-check-3"></i>Apply
                </base-button>
              </div>
            </div>

            <div v-else class="pb-4 mt-2">
              <base-alert type="secondary" class="alert-box">
                <h4><strong>Waiting!</strong></h4>

                To display the picture gallery, please choose both a Destination
                and a Vehicle.

                <img
                  src="~rhomtrip_assets/src/img/character/waiting.png"
                  alt="RhomTrip Timer"
                  class="img-fluid"
                />
              </base-alert>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8 col-lg-8 col-md-8 box-flex">
        <div class="card" :class="{ 'p-card': files.length === 0 }">
          <div class="row mb-1">
            <div class="col-6 align-self-center">
              <h2 class="subtitle">
                Pictures
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  width="350"
                  class="curp"
                >
                  <span>
                    The first photo uploaded is set as the cover photo by
                    default.
                    <br /><br />
                    <strong>Select photos of the gallery:</strong>
                    <br />
                    You can select images from the gallery. First click on one
                    or more photos to select them and then click the "Apply"
                    button
                    <br />
                    <br />
                    <strong> Upload New Photos:</strong>
                    <br />
                    Customers do select experiences based on how they look, so
                    make sure you choose good quality photographs that highlight
                    your activity.
                    <br />

                    <ul class="ul-pop">
                      <li><strong>Pictures:</strong> Required Maximum 5.</li>
                      <li><strong>Allowed Dimensions :</strong> 768x480 px.</li>
                      <li><strong>Maximum Size:</strong> 2MB.</li>
                      <li><strong>Allowed Formats:</strong> JPG/JPEG/PNG</li>
                      <li><strong>Resolution:</strong> Hight | 768x480 px.</li>
                    </ul>

                    <br />
                    <strong> Important:</strong> The images you upload from here
                    will not be associated with the vehicle or stored in the
                    gallery. To upload photos to the gallery you must do so from

                    <a target="blank" href="/tools/vehicles-gallery"> HERE</a>
                  </span>
                  <div class="badge badge-primary" slot="reference">?</div>
                </el-popover>
              </h2>
            </div>
            <div class="col-6 text-right align-self-center">
              <base-button
                type="outline-secondary"
                class="min-button"
                @click="uploadFile"
              >
                <i class="flaticon-arrow-up"></i>Upload New
              </base-button>
            </div>
          </div>

          <div
            class="box-drop"
            v-bind:class="{ 'invalid-card': error }"
            v-if="files.length > 0"
          >
            <div class="images-box image-box-1 row">
              <div
                v-for="(file, index) in files"
                :key="index"
                class="image-container"
                draggable
                @dragstart.stop="dragStart(index)"
                @dragover.prevent
                @drop.stop="drop(index)"
                @dragend.stop="dragEnd"
              >
                <div
                  class="image-wrapper"
                  @mouseover="showDeleteButton(index)"
                  @mouseleave="hideDeleteButton(index)"
                >
                  <div class="image-overlay"></div>
                  <img
                    v-lazy="`${file}`"
                    alt="Preview"
                    class="preview-image-3"
                  />
                  <base-button
                    class="delete-button"
                    @click.stop="deleteImage(index)"
                  >
                    <i class="flaticon-delete"></i>
                  </base-button>
                  <button
                    class="drag-button"
                    draggable
                    v-if="showDeleteButtons[index]"
                  >
                    <i class="flaticon-bold-drag"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 text-right">
              <span class="f-12">{{ files.length }} / 5</span>
            </div>

            <small class="invalid-feedback" v-if="error"
              >Select or upload 5 pictures</small
            >
          </div>

          <div v-else>
            <base-alert
              type="secondary"
              class="alert-box"
              v-bind:class="{ 'invalid-card': error }"
            >
              <h4><strong> No pictures available!</strong></h4>
              Please choose or upload five images.
              <img
                src="~rhomtrip_assets/src/img/character/waiting.png"
                alt="RhomTrip Timer"
                class="character"
              />
            </base-alert>

            <small class="invalid-feedback" v-if="error"
              >Select or upload 5 pictures</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BYTESCALE_API_PUBLIC_KEY } from "../../../../../core/config/env";
import { mapGetters, mapMutations } from "vuex";
import { VehiclesAPI } from "../../../../../core/api";
import lodash from "lodash";
const uploader = Uploader({
  apiKey: BYTESCALE_API_PUBLIC_KEY
});

export default {
  props: {
    images: {
      type: Array,
      default: () => []
    },
    searchCriteria: {
      type: Object,
      default: () => {}
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dragIndex: null,
      showDeleteButtons: [],
      files: [],
      filteredImages: [],
      imagesSelected: [],
      loadpreload: true,
      loadedVehicles: 0
    };
  },
  watch: {
    images: {
      handler: function(current, old) {
        this.files = current;
      },
      deep: true
    },
    searchCriteria: {
      handler: function(current, old) {
        this.getPictures();
      },
      deep: true
    }
  },

  created() {
    this.files = this.images;
    this.getPictures();
  },
  methods: {
    async uploadFile() {
      if (this.files.length < 5) {
        try {
          let files = await this.uploaderOpen(5 - this.files.length);
          if (files) {
            this.files.push(...files.map(file => file.fileUrl));
            this.$emit("uploaderManager", this.files);
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The Operation couldn't be completed. Please try again",
              icon: "flaticon-remove"
            });
          }
        } catch (error) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "No more than 5 images allowed",
          icon: "flaticon-warning-1"
        });
      }
    },
    async uploaderOpen(maxFileCount) {
      return await uploader.open({
        maxFileCount: maxFileCount,
        maxFileSizeBytes: 2000000,
        mimeTypes: ["image/jpeg", "image/png"],
        multi: true,
        styles: {
          colors: {
            active: "#528fff",
            error: "#d23f4d",
            primary: "#4b56a6"
          }
        },
        editor: {
          images: {
            crop: true,
            preview: true
          }
        },
        path: {
          folderPath: "/products/pictures",
          folderPathVariablesEnabled: true
        }
      });
    },
    deleteImage(index) {
      this.files.splice(index, 1);
      this.showDeleteButtons.splice(index, 1);
    },
    dragStart(index) {
      this.dragIndex = index;
    },
    drop(index) {
      if (this.dragIndex !== null) {
        const draggedImage = this.files[this.dragIndex];
        this.files.splice(this.dragIndex, 1);
        this.files.splice(index, 0, draggedImage);
        const draggedButton = this.showDeleteButtons[this.dragIndex];
        this.showDeleteButtons.splice(this.dragIndex, 1);
        this.showDeleteButtons.splice(index, 0, draggedButton);
      }
    },
    dragEnd() {
      this.dragIndex = null;
    },
    showDeleteButton(index) {
      this.$set(this.showDeleteButtons, index, true);
    },
    hideDeleteButton(index) {
      this.$set(this.showDeleteButtons, index, false);
    },
    async getPictures() {
      this.loadpreload = true;
      this.filteredImages = [];
      let { type, make, model } = this.searchCriteria.vehicle;
      let { destination } = this.searchCriteria;
      let pictures = [];
      let destinations = "";
      if (destination.slug != "") {
        destinations = [
          `https://upcdn.io/FW25b8h/raw/destinations/cities/${destination.slug}.jpg`
        ];

        this.filteredImages = lodash.cloneDeep(destinations);
      }

      if (type && make && model) {
        pictures = await this.getCarPicturesByDetails(type, make, model);

        if (pictures.length === 0) {
          this.loadedVehicles = 1;
        } else {
          this.loadedVehicles = 0;
          this.filteredImages = lodash.cloneDeep(pictures.concat(destinations));
        }
      } else {
        this.loadedVehicles = 2;
      }

      this.loadpreload = false;
    },

    showMessage() {},

    async getCarPicturesByDetails(type, make, model) {
      try {
        let { data } = await VehiclesAPI.getCarsByDetails(
          type,
          make,
          model,
          this.sesion.token
        );
        if (data.status) {
          return data.data.pictures;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    selectGallery() {
      let availables = 5 - this.files.length;
      if (this.imagesSelected.length <= availables) {
        this.files = lodash.cloneDeep(this.files.concat(this.imagesSelected));
        this.imagesSelected = [];
        this.$emit("uploaderManager", this.files);
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "You cannot add the number of selected images to the pictures section. To add more, remove those from the pictures section",
          icon: "flaticon-warning-1"
        });
      }
    },
    markAllGallery() {
      this.imagesSelected = lodash.cloneDeep(this.filteredImages);
    },
    unCkeckAllGallery() {
      this.imagesSelected = [];
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion"])
  }
};
</script>
